import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Feature } from '../feature'

/**
 * Starts loading an enhancement when the enhancement type is finally selected
 */
export const startLoadingEnhancementWhenTypeIsFinalized = store.effects.create(
  (feature: Feature) =>
    feature.actions.selectEnhancementType.observe().pipe(
      // We only need to load if we currently have an empty feed
      rxjs.filter(action => action.data.isFinalized),
      rxjs.map(action =>
        feature.actions.loadEnhancement.from(action).create({
          enhancementType: action.data.enhancementType,
        }),
      ),
    ),
)
